module.exports = __webpack_public_path__ + "img/IMG_20191015_215001.6f343da5.jpg";